<template>
  <div class="message-box" :class="type">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'MessageBox',
  props: {
    type: String
  }
}
</script>

<style scoped>
.message-box {
  line-height: 1.5;
  border-radius: .25rem;
  padding-top: .75rem;
  padding-bottom: .75rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-bottom-right-radius: .25rem;
  border-bottom-left-radius: .25rem;
  border: 0;
  border-top-width: 2px;
  border-style: solid;
  /*box-shadow: 0 4px 8px 0 rgba(0,0,0,.12),0 2px 4px 0 rgba(0,0,0,.08);*/
  margin-bottom: 15px;
}
.message-box.error {
  color: #cc1f1a;
  background-color: #fcebea;
  border: 1px solid #ef5753;
}
.message-box.success {
  background-color: #22c55e;
  border-color: #16a34a;
  color: #f0fdf4;
}
.message-box.info {
  background-color: #bee3f8;
  border-width: 1px;
  border-color: #4299e1;
  color: #2c5282;
}
</style>